/* istanbul ignore file */
export const FADE_TRANSITION_MS = 150;
